export default function productsRouteConfig($stateProvider): void {
  'ngInject';

  $stateProvider
    .state('index.menu-more.products', {
      url: '/products',
      abstract: true,
      template: '<ion-nav-view></ion-nav-view>',
    })
    .state('index.menu-more.products.scan', {
      url: '',
      template: `
        <ion-view cache-view="false">
          <sf-products-dashboard></sf-products-dashboard>
        </ion-view>
      `,
      controller: ProductsViewController,
      controllerAs: '$ctrl',
      analyticsName: 'Products',
      resolve: {},
    });

  function ProductsViewController() {
    'ngInject';
  }
}
